<section
  class="app-bra-top"
  [ngClass]="{
    loreal: bannerClassName() === 'loreal',
    redken: bannerClassName() === 'redken',
    kerastase: bannerClassName() === 'kerastase',
  }"
  [id]="BrandSection.TOP"
  [appAnimate]="'fadeIn'"
  [speed]="'faster'"
>
  <div class="app-bra-top__con">
    <div class="app-bra-top__con__lef">
      <img
        [ngSrc]="brandImage()"
        [alt]="brandTitle()"
        [width]="717"
        [height]="684"
        [priority]="true"
        [appAnimate]="'fadeIn'"
        [speed]="'fast'"
      />
    </div>
    <div
      class="app-bra-top__con__rig"
      [style.--app-bra-top-bg-color]="backgroundColor()"
      [style.--app-bra-top-color]="color()"
      [appAnimate]="'landing'"
      [speed]="'fast'"
    >
      @if (brandLogo()) {
        <img
          class="app-bra-top__con__rig__logo d-none d-md-block ms-1"
          [ngSrc]="brandLogo()"
          [alt]="brandTitle()"
          [width]="121"
          [height]="34"
          [priority]="true"
        />
      }
      @if (brandLogoMobile()) {
        <img
          class="app-bra-top__con__rig__logo d-block d-md-none ms-1"
          [ngSrc]="brandLogoMobile()"
          [alt]="brandTitle()"
          [width]="121"
          [height]="34"
          [priority]="true"
        />
      }

      @if (brandTitle()) {
        <h1 class="app-bra-top__con__rig__h1">{{ brandTitle() }}</h1>
      }
      <p class="app-bra-top__con__rig__p" [innerHtml]="brandDescription()"></p>
    </div>
  </div>
</section>
